import { cn } from "@/lib/utils";
import { PlaylistItemDTO } from "../../lib/types";

type Props = {
  item: PlaylistItemDTO;
  isFullScreen?: boolean;
};

export const DSPlayerImage: React.FC<Props> = ({ item, isFullScreen }) => {
  return (
    <img className={cn("ds-player-img", isFullScreen && "with-full-screen")} id={item.id.toString()} src={item.src} />
  );
};
